/**
 * Session-expired bridge for the axios interceptor.
 *
 * The axios instance lives outside React, but recovering from a dead session
 * (Auth0 refresh token revoked/expired while the app still looks logged in)
 * needs loginWithRedirect from the auth context. AuthContext registers a
 * handler while authenticated; the response interceptor fires it on a 401.
 *
 * One-shot: several parallel requests fail together when the session dies
 * (the admin panel fires four at once) - only the first triggers the
 * re-login redirect.
 */

type SessionExpiredHandler = () => void

let sessionExpiredHandler: SessionExpiredHandler | null = null
let triggered = false

export const setSessionExpiredHandler = (handler: SessionExpiredHandler): void => {
  sessionExpiredHandler = handler
  triggered = false
}

export const clearSessionExpiredHandler = (): void => {
  sessionExpiredHandler = null
  triggered = false
}

// No-op unless a handler is registered (i.e. the app believes it's logged in).
export const notifySessionExpired = (): void => {
  if (!sessionExpiredHandler || triggered) return
  triggered = true
  sessionExpiredHandler()
}
